import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

// https://mui.com/components/icons/#createsvgicon
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Resources = createSvgIcon(/*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 25 24",
  width: "25",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.1211 14.4C15.6557 14.4 18.5211 11.5346 18.5211 8C18.5211 4.46538 15.6557 1.6 12.1211 1.6C8.58647 1.6 5.72109 4.46538 5.72109 8C5.72109 11.5346 8.58647 14.4 12.1211 14.4ZM12.1211 16C16.5394 16 20.1211 12.4183 20.1211 8C20.1211 3.58172 16.5394 0 12.1211 0C7.70282 0 4.12109 3.58172 4.12109 8C4.12109 12.4183 7.70282 16 12.1211 16Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.1228 7.54251C12.8171 7.54251 13.3799 6.97967 13.3799 6.28537C13.3799 5.59106 12.8171 5.02822 12.1228 5.02822C11.4285 5.02822 10.8656 5.59106 10.8656 6.28537C10.8656 6.97967 11.4285 7.54251 12.1228 7.54251ZM12.1228 9.14251C13.7007 9.14251 14.9799 7.86332 14.9799 6.28537C14.9799 4.70741 13.7007 3.42822 12.1228 3.42822C10.5448 3.42822 9.26562 4.70741 9.26562 6.28537C9.26562 7.86332 10.5448 9.14251 12.1228 9.14251Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M9.48437 11.2998C8.74027 12.1291 8.35 13.0898 8.35 13.714H6.75C6.75 12.5708 7.38308 11.2458 8.29351 10.2312C9.215 9.20427 10.558 8.34253 12.1214 8.34253C13.6848 8.34253 15.0279 9.20427 15.9493 10.2312C16.8598 11.2458 17.4929 12.5708 17.4929 13.714H15.8929C15.8929 13.0898 15.5026 12.1291 14.7585 11.2998C14.0254 10.4828 13.0828 9.94253 12.1214 9.94253C11.1601 9.94253 10.2174 10.4828 9.48437 11.2998Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M11.498 21L11.498 15L12.6992 15L12.6992 21L11.498 21Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.1036 22.6786C12.5459 22.6786 12.9045 22.3201 12.9045 21.8778C12.9045 21.4355 12.5459 21.077 12.1036 21.077C11.6613 21.077 11.3028 21.4355 11.3028 21.8778C11.3028 22.3201 11.6613 22.6786 12.1036 22.6786ZM12.1036 23.8799C13.2093 23.8799 14.1057 22.9835 14.1057 21.8778C14.1057 20.7721 13.2093 19.8757 12.1036 19.8757C10.9979 19.8757 10.1016 20.7721 10.1016 21.8778C10.1016 22.9835 10.9979 23.8799 12.1036 23.8799Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M16.9048 18.1879L14.6953 14.3782L15.7344 13.7755L17.9439 17.5852L16.9048 18.1879Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M18.517 19.6309C18.8996 19.409 19.0299 18.9189 18.808 18.5363C18.5861 18.1537 18.096 18.0235 17.7134 18.2454C17.3308 18.4673 17.2006 18.9573 17.4225 19.3399C17.6444 19.7225 18.1344 19.8527 18.517 19.6309ZM19.1197 20.67C20.0761 20.1152 20.4018 18.8901 19.8471 17.9337C19.2923 16.9772 18.0672 16.6515 17.1108 17.2062C16.1543 17.761 15.8286 18.9861 16.3834 19.9426C16.9381 20.899 18.1632 21.2247 19.1197 20.67Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M6.12671 17.5562L8.3632 13.6996L9.40234 14.3022L7.16586 18.1588L6.12671 17.5562Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M5.6969 19.6308C6.07951 19.8527 6.56954 19.7224 6.79141 19.3398C7.01329 18.9572 6.883 18.4672 6.50039 18.2453C6.11779 18.0234 5.62776 18.1537 5.40588 18.5363C5.18401 18.9189 5.3143 19.4089 5.6969 19.6308ZM5.09429 20.67C6.0508 21.2247 7.27587 20.8989 7.83056 19.9424C8.38526 18.9859 8.05952 17.7608 7.10301 17.2061C6.1465 16.6514 4.92143 16.9772 4.36673 17.9337C3.81204 18.8902 4.13778 20.1153 5.09429 20.67Z",
    fill: "#6B6B6B",
    fillRule: "evenodd"
  })]
}), 'Resources');
// 0077D4
export var ResourcesHover = createSvgIcon(/*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 25 24",
  width: "25",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.1211 14.4C15.6557 14.4 18.5211 11.5346 18.5211 8C18.5211 4.46538 15.6557 1.6 12.1211 1.6C8.58647 1.6 5.72109 4.46538 5.72109 8C5.72109 11.5346 8.58647 14.4 12.1211 14.4ZM12.1211 16C16.5394 16 20.1211 12.4183 20.1211 8C20.1211 3.58172 16.5394 0 12.1211 0C7.70282 0 4.12109 3.58172 4.12109 8C4.12109 12.4183 7.70282 16 12.1211 16Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.1228 7.54251C12.8171 7.54251 13.3799 6.97967 13.3799 6.28537C13.3799 5.59106 12.8171 5.02822 12.1228 5.02822C11.4285 5.02822 10.8656 5.59106 10.8656 6.28537C10.8656 6.97967 11.4285 7.54251 12.1228 7.54251ZM12.1228 9.14251C13.7007 9.14251 14.9799 7.86332 14.9799 6.28537C14.9799 4.70741 13.7007 3.42822 12.1228 3.42822C10.5448 3.42822 9.26562 4.70741 9.26562 6.28537C9.26562 7.86332 10.5448 9.14251 12.1228 9.14251Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M9.48437 11.2998C8.74027 12.1291 8.35 13.0898 8.35 13.714H6.75C6.75 12.5708 7.38308 11.2458 8.29351 10.2312C9.215 9.20427 10.558 8.34253 12.1214 8.34253C13.6848 8.34253 15.0279 9.20427 15.9493 10.2312C16.8598 11.2458 17.4929 12.5708 17.4929 13.714H15.8929C15.8929 13.0898 15.5026 12.1291 14.7585 11.2998C14.0254 10.4828 13.0828 9.94253 12.1214 9.94253C11.1601 9.94253 10.2174 10.4828 9.48437 11.2998Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M11.498 21L11.498 15L12.6992 15L12.6992 21L11.498 21Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.1036 22.6786C12.5459 22.6786 12.9045 22.3201 12.9045 21.8778C12.9045 21.4355 12.5459 21.077 12.1036 21.077C11.6613 21.077 11.3028 21.4355 11.3028 21.8778C11.3028 22.3201 11.6613 22.6786 12.1036 22.6786ZM12.1036 23.8799C13.2093 23.8799 14.1057 22.9835 14.1057 21.8778C14.1057 20.7721 13.2093 19.8757 12.1036 19.8757C10.9979 19.8757 10.1016 20.7721 10.1016 21.8778C10.1016 22.9835 10.9979 23.8799 12.1036 23.8799Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M16.9048 18.1879L14.6953 14.3782L15.7344 13.7755L17.9439 17.5852L16.9048 18.1879Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M18.517 19.6309C18.8996 19.409 19.0299 18.9189 18.808 18.5363C18.5861 18.1537 18.096 18.0235 17.7134 18.2454C17.3308 18.4673 17.2006 18.9573 17.4225 19.3399C17.6444 19.7225 18.1344 19.8527 18.517 19.6309ZM19.1197 20.67C20.0761 20.1152 20.4018 18.8901 19.8471 17.9337C19.2923 16.9772 18.0672 16.6515 17.1108 17.2062C16.1543 17.761 15.8286 18.9861 16.3834 19.9426C16.9381 20.899 18.1632 21.2247 19.1197 20.67Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M6.12671 17.5562L8.3632 13.6996L9.40234 14.3022L7.16586 18.1588L6.12671 17.5562Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M5.6969 19.6308C6.07951 19.8527 6.56954 19.7224 6.79141 19.3398C7.01329 18.9572 6.883 18.4672 6.50039 18.2453C6.11779 18.0234 5.62776 18.1537 5.40588 18.5363C5.18401 18.9189 5.3143 19.4089 5.6969 19.6308ZM5.09429 20.67C6.0508 21.2247 7.27587 20.8989 7.83056 19.9424C8.38526 18.9859 8.05952 17.7608 7.10301 17.2061C6.1465 16.6514 4.92143 16.9772 4.36673 17.9337C3.81204 18.8902 4.13778 20.1153 5.09429 20.67Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  })]
}), 'ResourcesHover');
export var ResourcesFilled = createSvgIcon(/*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 25 24",
  width: "25",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.3867 14.4C15.9213 14.4 18.7867 11.5346 18.7867 8C18.7867 4.46538 15.9213 1.6 12.3867 1.6C8.8521 1.6 5.98672 4.46538 5.98672 8C5.98672 11.5346 8.8521 14.4 12.3867 14.4ZM12.3867 16C16.805 16 20.3867 12.4183 20.3867 8C20.3867 3.58172 16.805 0 12.3867 0C7.96844 0 4.38672 3.58172 4.38672 8C4.38672 12.4183 7.96844 16 12.3867 16Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.3884 9.14251C13.9663 9.14251 15.2455 7.86332 15.2455 6.28537C15.2455 4.70741 13.9663 3.42822 12.3884 3.42822C10.8104 3.42822 9.53125 4.70741 9.53125 6.28537C9.53125 7.86332 10.8104 9.14251 12.3884 9.14251Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.5112 13.7097L10.1205 13.6482C10.1162 13.6406 10.1119 13.6329 10.1074 13.6249C10.0295 13.4842 9.98147 13.3831 9.93162 13.2782C9.89626 13.2038 9.85997 13.1274 9.81138 13.0335C9.78969 12.9916 9.75852 12.9333 9.72165 12.8769C9.70334 12.849 9.67319 12.8052 9.632 12.7586C9.60132 12.7239 9.51057 12.6241 9.36078 12.5527C9.18815 12.4703 8.90128 12.4177 8.62207 12.5714H8.30477C8.50091 11.8599 8.9319 11.0847 9.52566 10.423C10.3534 9.50045 11.4964 8.8 12.7581 8.8C14.0199 8.8 15.1628 9.50045 15.9906 10.423C16.5844 11.0847 17.0154 11.8599 17.2115 12.5714H16.8689C16.7639 12.5184 16.6371 12.484 16.4877 12.4876C16.1924 12.4946 16.0057 12.6563 15.9608 12.6958C15.849 12.7943 15.7793 12.9102 15.7582 12.9453L15.7565 12.9481C15.7231 13.0035 15.6916 13.0633 15.6647 13.116C15.6142 13.2151 15.5693 13.3087 15.5237 13.4039C15.4532 13.5508 15.3809 13.7016 15.2831 13.8828C15.2301 13.981 15.181 14.0653 15.1367 14.136C15.0015 14.0284 14.8583 13.9388 14.7042 13.8705C14.4029 13.7369 14.1182 13.7105 13.8668 13.7234C13.6821 13.7329 13.486 13.7675 13.3396 13.7934C13.3108 13.7984 13.2839 13.8032 13.2594 13.8073C13.0875 13.8364 12.9316 13.8575 12.7578 13.8575H12.7546C11.8111 13.8575 11.4493 13.8575 10.5112 13.7097ZM9.78672 13.3714C9.78672 13.3585 9.78751 13.3617 9.78672 13.3765V13.3714ZM14.9293 14.4062C14.9293 14.4061 14.9308 14.4048 14.9337 14.4028C14.9307 14.4053 14.9293 14.4063 14.9293 14.4062Z",
    stroke: "#0077D4",
    "stroke-width": "1.6"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M11.7636 21L11.7636 15L12.9648 15L12.9648 21L11.7636 21Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M12.3693 23.8799C13.475 23.8799 14.3713 22.9835 14.3713 21.8778C14.3713 20.7721 13.475 19.8757 12.3693 19.8757C11.2635 19.8757 10.3672 20.7721 10.3672 21.8778C10.3672 22.9835 11.2635 23.8799 12.3693 23.8799Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M17.1704 18.1879L14.9609 14.3782L16 13.7755L18.2096 17.5852L17.1704 18.1879Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M19.3853 20.67C20.3418 20.1152 20.6674 18.8901 20.1127 17.9337C19.558 16.9772 18.3329 16.6515 17.3764 17.2062C16.4199 17.761 16.0942 18.9861 16.649 19.9426C17.2037 20.899 18.4288 21.2247 19.3853 20.67Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M6.39234 17.5562L8.62882 13.6996L9.66797 14.3022L7.43149 18.1588L6.39234 17.5562Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    clipRule: "evenodd",
    d: "M5.35991 20.67C6.31642 21.2247 7.5415 20.8989 8.09619 19.9424C8.65088 18.9859 8.32514 17.7608 7.36863 17.2061C6.41212 16.6514 5.18705 16.9772 4.63236 17.9337C4.07767 18.8902 4.4034 20.1153 5.35991 20.67Z",
    fill: "#0077D4",
    fillRule: "evenodd"
  })]
}), 'ResourcesFilled');